import PropTypes from 'prop-types';

import "@esri/calcite-components/components/calcite-icon";

import './confirmLogout.css';
import { DIALOG_TEXTS } from './constants';

export const CompConfirmLogout = ({
  isOpen,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="confirm-logout-wrapper">
        <div className="confirm-logout-container">

          <div className="confirm-header">
            <div className="header-content">
              <calcite-icon
                icon="sign-out"
                scale="m"
                className="header-icon"
              />

              <span>
                {DIALOG_TEXTS.HEADER}
              </span>
            </div>

            <button
              className="close-button"
              onClick={onCancel}
            >
              <calcite-icon
                icon="x"
                scale="s"
              />
            </button>
          </div>

          <div className="confirm-content">
            <p>
              {DIALOG_TEXTS.CONTENT}
            </p>

            <span className="content-description">
              {DIALOG_TEXTS.DESCRIPTION}
            </span>
          </div>

          <div className="confirm-footer">
            <button
              className="confirm-button outline"
              onClick={onCancel}
            >
              <calcite-icon
                icon="x"
                scale="s"
              />

              {DIALOG_TEXTS.CANCEL_BUTTON}
            </button>

            <button
              className="confirm-button danger"
              onClick={onConfirm}
            >
              <calcite-icon
                icon="sign-out"
                scale="s"
              />

              {DIALOG_TEXTS.LOGOUT_BUTTON}
            </button>
          </div>

        </div>
      </div>
    </>
  );
};

CompConfirmLogout.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default CompConfirmLogout;